import "react-toastify/dist/ReactToastify.css";

import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Campaign from "./components/Campaign/Campaign";
import CreateCampaign from "./components/Campaign/CreateCampaign/CreateCampaign";
import Home from "./components/Home/Home";
import Layout from "./components/Layout/Layout";
import LinkedFacebook from "./components/LinkedFacebook/LinkedFacebook";
import LiveAds from "./components/LiveAds/LiveAds";
import Login from "./components/UserAuth/Login/Login";
import Authorize from "./components/UserAuth/Authorize/Authorize";
import SetPassword from "./components/UserAuth/Password/SetPassword";
import InstamojoOAuth2Callback from "./components/UserAuth/Instamojo/OAuth2";
import { loginActions } from "./store/login-slice";
import { userActions } from "./store/user-slice";
import { stepsActions } from "./store/steps-slice";
import AddNewProduct from "./components/Campaign/CampaignSteps/CampaignStep2/AddNewProduct/AddNewProduct";
import Products from "./components/Products/Products";
import ConnectWhatsApp from "./components/Campaign/ConnectWhatsApp/ConnectWhatsApp";
import { fetchBusiness } from "./store/business-slice";
import { fetchHomepageProfile } from "./store/homepage-profile-slice";
import { sidebarActions } from "./store/sidebar-slice";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./config/api";
import { PuffLoader } from "react-spinners";
import ResetPassword from "./components/UserAuth/Resetpassword/Resetpassword";
import Brand from "./components/Brand/Brand";
import Profile from "./components/Profile/Profile";
import UNIVERSAL from "./config/config";

function External() {
  window.location.href =
    "https://www.instamojo.com/authservice/oauth2/authorize/?scope=payments:read%20payouts:read%20orders:read%20user-info:read%20user-contact:read%20store-inventory:read%20&redirect_uri=https://instamojo.zocket.com/oauth2/callback&response_type=code&client_id=1eCtWZeoc3KvpLWwJEr9ftf8UsBl4HT1dsiWwjij&state=af0ifjsldkj";
  return (
    <>
      <div className="puffLoadingSpinner">
        <PuffLoader size={100} color="#0F6EFF" />
      </div>
    </>
  );
}

const App = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.login.isLogin);
  const user = useSelector((state) => state.user.user);
  const stepNo = useSelector((state) => state.steps.stepNumber);
  const [userData, setUserData] = useState();
  const [updated,setUpdated]=useState();

  useEffect(() => {
    const user_json = localStorage.getItem("auth");
    const user = JSON.parse(user_json);
    if (!user) {
      dispatch(sidebarActions.setSidebar(false));
      navigate("/auth/login");
      return;
    }

    dispatch(loginActions.setIsLogin(true));
    dispatch(loginActions.setToken(user.access_token));
    dispatch(userActions.updateUser({ user: user.user, username: "" }));
    dispatch(stepsActions.selectedCategory(user.user?.business_category));
    // navigate("/");
  }, []);

  useEffect(() => {
    if (user?.app_business_id) {
    dispatch(
      fetchBusiness({
        businessId: user?.app_business_id,
      })
    );

    dispatch(fetchHomepageProfile({ businessId: user?.app_business_id }));
    }
  }, [user?.app_business_id]);

  useEffect(() => {
    if (user?.app_business_id) {
      async function getUserProfile() {
        return fetch(UNIVERSAL.BASEURL_1 + "/biz/getBiz", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
          },
          body: JSON.stringify({
            businessId: user?.app_business_id,
          }),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson) {
              setUserData(responseJson.data);
            } else {
              // error
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      getUserProfile();
    }
  }, [user, updated]);

  return (
    <QueryClientProvider client={queryClient}>
      <Layout>
        <Routes>
          {isLogin && <Route exact path="/" element={<Home />} />}
          {isLogin && <Route exact path="/campaign" element={<Campaign />} />}
          {isLogin && <Route exact path="/create-campaign" element={<CreateCampaign stepNo={stepNo} />} />}
          {isLogin && <Route exact path="/live-ads" element={<LiveAds />} />}
          {isLogin && <Route exact path="/products" element={<Products />} />}
          {isLogin && <Route exact path="/products/:addUpdateProduct" element={<AddNewProduct />} />}
          <Route exact path="/oauth" element={<External />} />
          <Route path="/oauth2/callback" element={<InstamojoOAuth2Callback />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/reset_password" element={<ResetPassword />} />
          {isLogin && <Route path="/auth/password/set" element={<SetPassword />} />}
          <Route path="/auth/authorize" element={<Authorize />} />
          {isLogin && <Route path="/linked-facebook" element={<LinkedFacebook />} />}
          {isLogin && <Route path="/connect-whatsapp" element={<ConnectWhatsApp />} />}
          {isLogin && <Route path="/brand" element={<Brand />} />}
          {isLogin && <Route path="/profile" element={<Profile user={user} userData={userData} setUpdated={setUpdated} />} />}
          {/* {isLogin && isLogin ? <Route path="*" element={<Navigate to="/" />} /> : <Route path="*" element={<Navigate to="/auth/login" />} />} */}
        </Routes>
      </Layout>
      <ToastContainer />
    </QueryClientProvider>
  );
};

export default App;
